// Game-facing call forms. Each choice records its footprint and parameter recipe.
const numericForms = () => [{id:'array',name:'货箱进料',detail:'一份货箱 · 一个入口',rows:1,args:[]}].concat(Array.from({length:8},(_,i)=>({id:'numbers-'+(i+1),name:(i+1)+' 路数字进料',detail:(i+1)+' 个入口 · 第一行出料',rows:i+1,args:[],collector:true})))
export function overloadsFor(id){
  if(id==='Math.min')return numericForms()
  if(id==='Math.pow'||id==='operator.multiply')return [{id:'recipe',name:'配方进料',detail:'一个入口 · 在配方中设置倍率',rows:1,args:[2]},{id:'two-inputs',name:'双路数字进料',detail:'两个入口 · 第一行出料',rows:2,args:[],collector:true}]
  if(id==='Array.concat')return [{id:'recipe',name:'固定拼箱',detail:'一个入口 · 在配方中登记另一箱',rows:1,args:[[4,5]]},{id:'two-inputs',name:'双路拼箱',detail:'两个入口 · 第一行出料',rows:2,args:[],collector:true}]
  if(id==='Array.slice'||id==='String.slice')return [{id:'start',name:'剪到末尾',detail:'设置起点',rows:1,args:[0]},{id:'range',name:'剪取一段',detail:'设置起点和终点',rows:1,args:[0,5]}]
  if(id==='Number.toFixed')return [{id:'default',name:'整位誊写',detail:'不保留小数位',rows:1,args:[]},{id:'digits',name:'指定位数',detail:'在配方中设置小数位数',rows:1,args:[2]}]
  if(id==='Number.parseInt')return [{id:'default',name:'自动读数',detail:'按来料文字识别',rows:1,args:[]},{id:'radix',name:'指定进制',detail:'在配方中设置进制',rows:1,args:[10]}]
  if(id==='String.split')return [{id:'whole',name:'整封装箱',detail:'不剪分文字',rows:1,args:[]},{id:'separator',name:'按标记剪分',detail:'在配方中设置分隔文字',rows:1,args:[' ']}]
  if(id==='Array.join')return [{id:'default',name:'逗号装订',detail:'用逗号连接货物文字',rows:1,args:[]},{id:'separator',name:'指定装订',detail:'在配方中设置连接文字',rows:1,args:[',']}]
  return []
}
export function machineForm(type,variant){
  if(type==='Math.max'){
    if(variant==='array')return {id:'array',rows:1,args:[]}
    const match=/^numbers-([1-9]\d*)$/.exec(variant||'');const rows=match?Number(match[1]):0
    if(Number.isInteger(rows)&&rows<=64&&rows>=1)return {id:variant,rows,args:[],collector:true}
    return null
  }
  return overloadsFor(type).find(form=>form.id===variant)||null
}
export function machineRows(building){return Number.isInteger(building.rows)&&building.rows>=1&&building.rows<=64?building.rows:1}
export function isCollector(building){return !!machineForm(building.type,building.variant)?.collector}
export function footprint(building){return Array.from({length:machineRows(building)},(_,row)=>({x:building.x,y:building.y+row}))}
export function runCollector(type,values){
  if(type==='Math.max')return Math.max(...values)
  if(type==='Math.min')return Math.min(...values)
  if(type==='Math.pow')return Math.pow(values[0],values[1])
  if(type==='operator.multiply')return values[0]*values[1]
  if(type==='Array.concat'){if(!Array.isArray(values[0]))throw new Error('需要货箱');return values[0].concat(values[1])}
  throw new Error('未知汇料设备')
}
export function collectorCode(type,items){
  const codes=items.map(item=>(item.lines||[]).length?'(() => { '+item.lines.join(' ')+' return '+item.code+'; })()':item.code)
  if(type==='operator.multiply')return '('+codes[0]+') * ('+codes[1]+')'
  if(type==='Array.concat')return '('+codes[0]+').concat('+codes[1]+')'
  return type+'('+codes.join(', ')+')'
}
